<script setup>
defineProps({
  // blocks: Array of { title, body, facts:[[k,v]], openTitle, open }
  blocks: { type: Array, default: () => [] }
})
</script>

<template>
  <section class="block tight">
    <div class="wrap">
      <div class="sec-h"><h2>Format details</h2></div>
      <div class="faq-list">
        <template v-for="(block, i) in blocks" :key="i">
          <AccordionItem :title="block.title">
            <p v-html="block.body" />
            <div class="fmt-facts">
              <div v-for="(fact, fi) in block.facts" :key="fi" class="ff">
                <span class="fk">{{ fact[0] }}</span>
                <span class="fv">{{ fact[1] }}</span>
              </div>
            </div>
          </AccordionItem>
          <AccordionItem :title="block.openTitle">
            <p v-html="block.open" />
          </AccordionItem>
        </template>
      </div>
    </div>
  </section>
</template>
